import React from 'react';
import { VideoSourceEnum } from 'api';
import { observer } from 'mobx-react';
import useStyles from './VideosTab.styles';
import { useVideoTabs } from './hooks/useVideoTabs';
import { VideoUploader } from './components/VideoUploader';
import { useVideosGallery } from './hooks/useVideosGallery';
import { useVideoUploaderDialog } from './hooks/useVideoUploaderDialog';
import { VideosGallery } from './components/VideosGallery/VideosGallery';
import { VideoExtractor } from './components/VideoExtractor/VideoExtractor';

export const VideosTab: React.FC = observer(() => {
  const classes = useStyles();

  const { activeVideoTab } = useVideoTabs();
  const { videos, handleVideoSelect, isSelected } = useVideosGallery();
  const { handleCloseVideoUploaderDialog, openVideoUploaderDialog } = useVideoUploaderDialog();

  return (
    <div className={classes.Root}>
      {activeVideoTab === VideoSourceEnum.PAGE && (
        <VideosGallery
          data={videos}
          isSelected={isSelected}
          videoSource={VideoSourceEnum.PAGE}
          handleVideoSelect={handleVideoSelect}
        />
      )}

      {activeVideoTab === VideoSourceEnum.ACCOUNT && (
        <VideosGallery
          data={videos}
          isSelected={isSelected}
          handleVideoSelect={handleVideoSelect}
          videoSource={VideoSourceEnum.ACCOUNT}
        />
      )}

      {activeVideoTab === VideoSourceEnum.MANUAL && (
        <>
          <VideoExtractor />
          <VideosGallery
            data={videos}
            isSelected={isSelected}
            handleVideoSelect={handleVideoSelect}
            videoSource={VideoSourceEnum.MANUAL}
          />
        </>
      )}

      {openVideoUploaderDialog && (
        <VideoUploader open={openVideoUploaderDialog} onClose={handleCloseVideoUploaderDialog} />
      )}
    </div>
  );
});
